/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_age_total_weeks = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total weeks`)
};

const es_age_total_weeks = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de semanas`)
};

const de_age_total_weeks = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamte Wochen`)
};

const nl_age_total_weeks = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totaal weken`)
};

const fr_age_total_weeks = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre total de semaines`)
};

const it_age_total_weeks = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settimane totali`)
};

const pt_br2_age_total_weeks = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de semanas`)
};

const pt_age_total_weeks = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de semanas`)
};

const ja_age_total_weeks = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`総週数`)
};

const zh_age_total_weeks = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总周数`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const age_total_weeks = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.age_total_weeks(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("age_total_weeks", locale)
	if (locale === "en") return en_age_total_weeks(inputs)
	if (locale === "es") return es_age_total_weeks(inputs)
	if (locale === "de") return de_age_total_weeks(inputs)
	if (locale === "nl") return nl_age_total_weeks(inputs)
	if (locale === "fr") return fr_age_total_weeks(inputs)
	if (locale === "it") return it_age_total_weeks(inputs)
	if (locale === "pt-BR") return pt_br2_age_total_weeks(inputs)
	if (locale === "pt") return pt_age_total_weeks(inputs)
	if (locale === "ja") return ja_age_total_weeks(inputs)
	return zh_age_total_weeks(inputs)
};